import * as React from 'react';
import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@klareospace/pharos-lib-web-utils';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface ComputableValueCellProps {
  readonly formatted: string;
  readonly isComputed: boolean | undefined;
  readonly isError?: boolean;
}

// ─── Component ────────────────────────────────────────────────────────────────

/** Displays a formatted value with a sparkle tooltip when the value was computed by Klareo. */
export function ComputableValueCell({
  formatted,
  isComputed,
  isError = false,
}: ComputableValueCellProps): React.JSX.Element {
  const { t } = useTranslation('orders');

  return (
    <span className={`flex items-center gap-1.5 text-sm ${isError ? 'text-destructive' : 'text-foreground'}`}>
      {formatted}
      {isComputed === true && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="inline-flex cursor-default">
                <Sparkles className="w-3 h-3 text-muted-foreground shrink-0" />
              </span>
            </TooltipTrigger>
            <TooltipContent>
              <p>{t('drawer.computedByKlareo')}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </span>
  );
}
